"use client"

import { useState, useEffect } from "react"
import { addChallenge, updateChallenge } from "../comman/Challenges.js"

const AddChallengeModal = ({ isOpen, onClose, onAddChallenge, onUpdateChallenge, challengeToEdit }) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    coins: "",
    isPublic: false,
    level: "",
    sport: "",
  })

  const [image, setImage] = useState(null)
  const [fileName, setFileName] = useState("")

  const sportsList = [
    "Cricket",
    "Football",
    "Basketball",
    "Tennis",
    "Badminton",
    "Baseball",
    "Volleyball",
    "Hockey",
    "Table Tennis",
  ]

  const categories = ["Beginner", "Amateur", "Intermediate", "Advanced", "Professional"]

  useEffect(() => {
    if (challengeToEdit) {
      setFormData({
        name: challengeToEdit.name || "",
        category: challengeToEdit.category || "",
        coins: challengeToEdit.coins || "",
        isPublic: challengeToEdit.isPublic || false,
        level: challengeToEdit.level || "",
        sport: challengeToEdit.sport || "",
      })
      setFileName(challengeToEdit.imageName || "")
    } else {
      resetForm()
    }
  }, [challengeToEdit])

  const resetForm = () => {
    setFormData({
      name: "",
      category: "",
      coins: "",
      isPublic: false,
      level: "",
      sport: "",
    })
    setImage(null)
    setFileName("")
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0]
    setImage(selectedImage)
    setFileName(selectedImage ? selectedImage.name : "")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const updatedFormData = new FormData()
      Object.keys(formData).forEach((key) => {
        updatedFormData.append(key, formData[key])
      })

      if (image) {
        updatedFormData.append("image", image)
      }

      if (challengeToEdit) {
        updatedFormData.append("challengeId", challengeToEdit._id)
        const updatedChallenge = await updateChallenge(updatedFormData)
        onUpdateChallenge(updatedChallenge)
      } else {
        const newChallenge = await addChallenge(updatedFormData)
        onAddChallenge(newChallenge)
      }
      onClose()
    } catch (error) {
      console.error("Error occurred while submitting challenge:", error)
      alert("Error occurred while submitting challenge")
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800">
              {challengeToEdit ? "Edit Challenge" : "Add Challenge"}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Challenge Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter challenge name"
                required
              />
            </div>
            <div>
              <label htmlFor="sport" className="block text-sm font-medium text-gray-700 mb-1">
                Sport
              </label>
              <select
                id="sport"
                name="sport"
                value={formData.sport}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              >
                <option value="">Select Sport</option>
                {sportsList.map((sport, index) => (
                  <option key={index} value={sport}>
                    {sport}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
                Category
              </label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              >
                <option value="">Select Category</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="coins" className="block text-sm font-medium text-gray-700 mb-1">
                Coins
              </label>
              <input
                type="number"
                id="coins"
                name="coins"
                value={formData.coins}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter coins"
                required
              />
            </div>
            <div>
              <label htmlFor="level" className="block text-sm font-medium text-gray-700 mb-1">
                Level
              </label>
              <input
                type="text"
                id="level"
                name="level"
                value={formData.level}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter level"
                required
              />
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="isPublic"
                name="isPublic"
                checked={formData.isPublic}
                onChange={handleChange}
                className="h-4 w-4 text-[#12143F] focus:ring-[#12143F] border-gray-300 rounded"
              />
              <label htmlFor="isPublic" className="ml-2 block text-sm text-gray-900">
                Make challenge public
              </label>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Challenge Image</label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-gray-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="flex text-sm text-gray-600">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer bg-white rounded-md font-medium text-[#12143F] hover:text-[#12143F] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#12143F]"
                    >
                      <span>Upload a file</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        className="sr-only"
                        onChange={handleImageChange}
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                </div>
              </div>
              {fileName && <p className="mt-2 text-sm text-gray-500">Selected file: {fileName}</p>}
            </div>
          </form>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#12143F] text-base font-medium text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:ml-3 sm:w-auto sm:text-sm"
          >
            {challengeToEdit ? "Update Challenge" : "Add Challenge"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddChallengeModal

